import React, {Component} from 'react';

import {Card} from 'primereact/card';

import {defaultBaseRequestParameters} from '~/shared/src/utilities/modules/common';
import EnumProperty from '~/shared/src/ci/EnumProperty';
import PropertySet from '~/shared/src/mm/PropertySet';

import EnumPropertiesDataTable from '~/frontend/src/components/base/ItemFinder/detail/EnumPropertyPanel/EnumPropertyDataTable';


const defaultProps = {
    ...defaultBaseRequestParameters,

    /**
     * Show the MetaModel information as defined (raw) <strong>or</strong> should they be processed by MessageCatalog.
     */
    rawMode: false as boolean,

    /**
     * Show the MetaModel information as defined additionally for processed information.
     * This applies in the form: &lt;processed MetaModel information&gt; (&lt;defined MetaModel information&gt;)
     *
     * Only applicable if <prop>rawMode</prop> is set to false.
     */
    showAdditionalRawNames: false as boolean,

    /**
     * Is data in this form editable at all?
     */
    editable: false as boolean
};

type DefaultProps = typeof defaultProps;

type Props = {

    /**
     * The uniqueId of the panel the component is used in.
     *
     * Mostly used to extract the components state from the global one
     * and to generate unique dom element ids.
     */
    uid : string;

    /**
     * The dataContext to access global.data with.
     */
    dataContext : string;

    /**
     * The itemId the enumerated property belongs to.
     */
    itemId : number;

    /**
     * The statusId of the item the enumerated property belongs to.
     */
    itemStatusId : number;

    /**
     * The enumerated property.
     */
    enumProperty? : EnumProperty;

    /**
     * The PropertySet the enumerated property to show for.
     */
    propertySet : PropertySet;

    subPanelProps? : any;
};

export type ComponentProps = Partial<DefaultProps> & Props;
type AllProps = DefaultProps & Props;

/**
 * EnumPropertyPanel
 */
class EnumPropertyPanel extends Component<AllProps> {

    static defaultProps = defaultProps;

    /**
     * REDUX stuff
     */
    constructor( props : AllProps ) {
        super( props );
    }

    /**
     * REDUX stuff
     */
    render() {
        const {
                  uid,
                  dataContext,
                  schema,
                  status,
                  timestamp,
                  timezone,
                  itemId,
                  itemStatusId,
                  enumProperty,
                  propertySet,
                  rawMode,
                  showAdditionalRawNames,
                  editable,
                  subPanelProps
              }              = this.props,
              dataTableKey   = 'enumPropertyDataTable',
              dataTableProps = subPanelProps?.[ dataTableKey ] ?? {};

        return <div className="yn-card-content-panel yn-flex-layout-parent">
            <Card className="yn-flex-layout-parent">
                <EnumPropertiesDataTable
                    uid={`${uid}_${dataTableKey}`}
                    dataContext={dataContext}

                    schema={schema}
                    status={status}
                    timestamp={timestamp}
                    timezone={timezone}

                    itemId={itemId}
                    itemStatusId={itemStatusId}
                    enumProperty={enumProperty}
                    propertySet={propertySet}

                    rawMode={rawMode}
                    showAdditionalRawNames={showAdditionalRawNames}

                    editable={editable}

                    {...dataTableProps}
                />
            </Card>
        </div>;
    }
}

export default EnumPropertyPanel;

